export default [
  // calendar
  {
    path: '/configuracao/calendario',
    name: 'calendar-list',
    component: () => import('@/views/pages/settings/calendar/CalendarList.vue'),
    meta: {
      pageTitle: 'Calendário',
      navActiveLink: 'calendar-list',
      resource: 'SeasonalCalendar',
      action: 'Read',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Calendário', active: true },
      ],
    },
  },
  // contaGerencial list
  {
    path: '/configuracao/financeiro/plano-de-contas-gerencial',
    name: 'management-account-list',
    component: () =>
      import('@/views/pages/settings/financial/management-account/ManagementAccountList.vue'),
    meta: {
      pageTitle: 'Contas Gerenciais',
      navActiveLink: 'management-account-list',
      resource: 'ManagementAccount',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Financeiro',
        },
        {
          text: 'Contas Gerenciais',
          active: true,
        },
      ],
    },
  },
  // contaCorrente list
  {
    path: '/financeiro/conta-corrente',
    name: 'checking-account-list',
    component: () => import('@/views/pages/financial/checking-account/CheckingAccountList.vue'),
    meta: {
      pageTitle: 'Conta Corrente',
      navActiveLink: 'checking-account-list',
      resource: 'CheckingAccount',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Financeiro',
        },
        {
          text: 'Conta corrente',
        },
        {
          text: 'Cadastro',
          active: true,
        },
      ],
    },
  },
  // ContaCorrente extrato list
  {
    path: '/financeiro/conta-corrente/extrato',
    name: 'checking-account-entry-list',
    component: () =>
      import('@/views/pages/financial/checking-account-entry/CheckingAccountEntryList.vue'),
    meta: {
      pageTitle: 'Extrato',
      navActiveLink: 'checking-account-entry-list',
      resource: 'CheckingAccountEntry',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Financeiro',
        },
        {
          text: 'Conta corrente',
        },
        {
          text: 'Extrato',
          active: true,
        },
      ],
    },
  },
  // contaCorrente transferencias list
  {
    path: '/financeiro/conta-corrente/transferencias',
    name: 'checking-account-transference-list',
    component: () =>
      import('@/views/pages/financial/checking-account-transfer/CheckingAccountTransferList.vue'),
    meta: {
      pageTitle: 'Transferências',
      navActiveLink: 'checking-account-transference-list',
      resource: 'CheckingAccountTransfer',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Financeiro',
        },
        {
          text: 'Conta corrente',
        },
        {
          text: 'Transferências',
          active: true,
        },
      ],
    },
  },
  // contaCorrente transferencias bulk maintain
  {
    path: '/financeiro/conta-corrente/transferencias/deposito/importacao',
    name: 'checking-account-bank-deposit-bulk',
    component: () =>
      import('@/views/pages/financial/checking-account-transfer/BankDepositBulkMaintain.vue'),
    meta: {
      pageTitle: 'Importação de depósitos',
      navActiveLink: 'checking-account-transference-list',
      resource: 'BankDeposit',
      action: 'BulkCreateFromImport',
      breadcrumb: [
        {
          text: 'Financeiro',
        },
        {
          text: 'Conta corrente',
        },
        {
          text: 'Transferências',
        },
        {
          text: 'Importação de depósitos',
          active: true,
        },
      ],
    },
  },
  // formasDePagamento list
  {
    path: '/configuracao/financeiro/formas-de-pagamento',
    name: 'payment-type-list',
    component: () => import('@/views/pages/settings/financial/payment-type/PaymentTypeList.vue'),
    meta: {
      pageTitle: 'Formas de pagamento',
      navActiveLink: 'payment-type-list',
      resource: 'PaymentMethod',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Financeiro',
        },
        {
          text: 'Formas de pagamento',
          active: true,
        },
      ],
    },
  },
  // Cartao list
  {
    path: '/configuracao/financeiro/cartao',
    name: 'card-list',
    component: () => import('@/views/pages/settings/financial/card/CardList.vue'),
    meta: {
      pageTitle: 'Cartão de Crédito/Débito',
      navActiveLink: 'card-list',
      resource: 'SettingsFinancialCards',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Financeiro',
        },
        {
          text: 'Cartão de Crédito/Débito',
          active: true,
        },
      ],
    },
  },
  // Cartao add
  {
    path: '/configuracao/financeiro/cartao/adicionar',
    name: 'card-add',
    component: () => import('@/views/pages/settings/financial/card/CardMaintain.vue'),
    meta: {
      pageTitle: 'Novo Cartão de Crédito/Débito',
      navActiveLink: 'card-list',
      resource: 'SettingsFinancialCards',
      action: 'Create',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Financeiro',
        },
        {
          text: 'Cartão de Crédito/Débito',
        },
        {
          text: 'Novo Cartão de Crédito/Débito',
          active: true,
        },
      ],
    },
  },
  // Reward Configuration
  {
    path: '/configuracao/vendas/recompensas',
    name: 'reward-configuration',
    component: () => import('@/views/pages/settings/reward/RewardConfiguration.vue'),
    meta: {
      pageTitle: 'Configuração de Recompensas',
      navActiveLink: 'reward-configuration',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Vendas',
        },
        {
          text: 'Recompensas',
          active: true,
        },
      ],
    },
  },
  // Lending Contract Configuration
  {
    path: '/configuracao/vendas/contrato-comodato',
    name: 'lending-contract-configuration',
    component: () => import('@/views/pages/settings/lending-contract/LendingContractConfiguration.vue'),
    meta: {
      pageTitle: 'Configuração do Contrato de Comodato',
      navActiveLink: 'lending-contract-configuration',
      resource: 'LendingContract',
      action: 'Update',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Vendas',
        },
        {
          text: 'Contrato Comodato',
          active: true,
        },
      ],
    },
  },
  // Cartao maintain
  {
    path: '/configuracao/financeiro/cartao/manter/:id',
    name: 'card-maintain',
    component: () => import('@/views/pages/settings/financial/card/CardMaintain.vue'),
    meta: {
      pageTitle: 'Editar Cartão de Crédito/Débito',
      navActiveLink: 'card-list',
      resource: 'SettingsFinancialCards',
      action: 'Update',
      breadcrumb: [
        {
          text: 'Configurações',
        },
        {
          text: 'Financeiro',
        },
        {
          text: 'Cartão de Crédito/Débito',
        },
        {
          text: 'Editar Cartão de Crédito/Débito',
          active: true,
        },
      ],
    },
  },
  // Custo de adquirente - lista
  {
    path: '/configuracao/financeiro/custo-adquirente',
    name: 'acquirer-cost-config-list',
    component: () =>
      import(
        '@/views/pages/settings/financial/acquirer-cost-config/AcquirerCostConfigList.vue'
      ),
    meta: {
      pageTitle: 'Custo de Adquirente',
      navActiveLink: 'acquirer-cost-config-list',
      resource: 'SettingsFinancialAcquirerCostConfigs',
      action: 'Read',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Custo de Adquirente', active: true },
      ],
    },
  },
  // Custo de adquirente - novo
  {
    path: '/configuracao/financeiro/custo-adquirente/adicionar',
    name: 'acquirer-cost-config-add',
    component: () =>
      import(
        '@/views/pages/settings/financial/acquirer-cost-config/AcquirerCostConfigMaintain.vue'
      ),
    meta: {
      pageTitle: 'Nova Configuração de Custo',
      navActiveLink: 'acquirer-cost-config-list',
      resource: 'SettingsFinancialAcquirerCostConfigs',
      action: 'Create',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Custo de Adquirente' },
        { text: 'Nova Configuração de Custo', active: true },
      ],
    },
  },
  // Custo de adquirente - editar
  {
    path: '/configuracao/financeiro/custo-adquirente/manter/:id',
    name: 'acquirer-cost-config-maintain',
    component: () =>
      import(
        '@/views/pages/settings/financial/acquirer-cost-config/AcquirerCostConfigMaintain.vue'
      ),
    meta: {
      pageTitle: 'Editar Configuração de Custo',
      navActiveLink: 'acquirer-cost-config-list',
      resource: 'SettingsFinancialAcquirerCostConfigs',
      action: 'Update',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Custo de Adquirente' },
        { text: 'Editar Configuração de Custo', active: true },
      ],
    },
  },
  // Politica de parcelamento - lista
  {
    path: '/configuracao/financeiro/politica-parcelamento',
    name: 'installment-policy-list',
    component: () =>
      import(
        '@/views/pages/settings/financial/installment-policy/InstallmentPolicyList.vue'
      ),
    meta: {
      pageTitle: 'Política de Parcelamento',
      navActiveLink: 'installment-policy-list',
      resource: 'SettingsFinancialInstallmentPolicies',
      action: 'Read',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Política de Parcelamento', active: true },
      ],
    },
  },
  // Politica de parcelamento - nova
  {
    path: '/configuracao/financeiro/politica-parcelamento/adicionar',
    name: 'installment-policy-add',
    component: () =>
      import(
        '@/views/pages/settings/financial/installment-policy/InstallmentPolicyMaintain.vue'
      ),
    meta: {
      pageTitle: 'Nova Política de Parcelamento',
      navActiveLink: 'installment-policy-list',
      resource: 'SettingsFinancialInstallmentPolicies',
      action: 'Create',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Política de Parcelamento' },
        { text: 'Nova Política de Parcelamento', active: true },
      ],
    },
  },
  // Politica de parcelamento - editar
  {
    path: '/configuracao/financeiro/politica-parcelamento/manter/:id',
    name: 'installment-policy-maintain',
    component: () =>
      import(
        '@/views/pages/settings/financial/installment-policy/InstallmentPolicyMaintain.vue'
      ),
    meta: {
      pageTitle: 'Editar Política de Parcelamento',
      navActiveLink: 'installment-policy-list',
      resource: 'SettingsFinancialInstallmentPolicies',
      action: 'Update',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Financeiro' },
        { text: 'Política de Parcelamento' },
        { text: 'Editar Política de Parcelamento', active: true },
      ],
    },
  },
  // parâmetros
  {
    path: '/configuracao/parametros',
    name: 'parameter-maintenance',
    component: () => import('@/views/pages/settings/parameter/ParameterMaintenance.vue'),
    meta: {
      pageTitle: 'Parâmetros do Sistema',
      navActiveLink: 'parameter-maintenance',
      resource: 'Parameter',
      action: 'Update',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Parâmetros do Sistema', active: true },
      ],
    },
  },
]
